export default __webpack_public_path__ + "static/media/List-documentation.e635d2d7.md";